export const SMS_ENROLLMENT = 'SMS_ENROLLMENT';
export const SMS_ENROLLED = 'SMS_ENROLLED';
export const ERROR_SCREEN = 'ERROR_SCREEN';
